export const goToHome = (navigate) => {
    navigate(`/`)
}
export const goToLogin = (navigate) => {
    navigate("/login")
}
